<template>
    <div class="connection-status" :class="statusClass">
        <div v-if="!isWebSocketConnected">
            <SvgIcon name="refresh" width="2rem" height="2rem" @click.stop="attemptReconnect" /> Lost connection to
            server. Tap to retry
        </div>
    </div>
</template>

<script>
export default {
    name: 'TerminalStatusMenu',
    components: {
    },
    props: {
        isWebSocketConnected: {
            type: Boolean,
            required: true,
            default: false
        },
        initialized: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
        };
    },
    computed: {
        statusClass() {
            return {
                connected: this.initialized && this.isWebSocketConnected,
                disconnected: !this.initialized || !this.isWebSocketConnected,
            };
        },
    },
    methods: {
        attemptReconnect() {
            console.log("Attempt to reconnect triggered");
            this.$emit('attempt-reconnect');
        },
    },
};
</script>

<style scoped>
.connection-status {
    position: fixed;
    top: 0.25rem;
    left: 0.25rem;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: grey;
    z-index: 900;
    transition: background-color 0.3s;
}

.connection-status.connected {
    background-color: green;
}

.connection-status.disconnected {
    font-size: 1.5rem;
    padding: 1rem 2rem;
    width: auto;
    height: auto;
    border-radius: 5rem;
    color: var(--primary-white);
    box-shadow: 0 0.3rem 0.5rem rgba(0, 0, 0, 0.1);
    cursor: pointer;
}
</style>